import { Component, OnInit, Input } from '@angular/core';
import { ProvidersBillingService } from 'app/pages/providers-billing/providers-billing-service.service';
import { GridOptions } from 'ag-grid';
import { EOPButtonComponent } from 'app/pages/A2-utils/grid-components/eop-button/eop-button.component';
import { ClaimButtonComponent } from 'app/pages/A2-utils/grid-components/claim-button/claim-button.component';

@Component({
  selector: 'app-batch-pay-detail',
  templateUrl: './batch-pay-detail.component.html',
  styleUrls: ['./batch-pay-detail.component.scss']
})
export class BatchPayDetailComponent implements OnInit {

  @Input() private batchid: number;
  @Input() private providerid: number;
  protected grid = <GridOptions> {};

  batchData: any;

  constructor(
    private service: ProvidersBillingService
  ) {
    this.grid.columnDefs = this.getColumns();
   }

  ngOnInit() {
    this.getPaidBatchDetails();
    if (this.providerid) {
      this.service.setCompanyId(this.providerid);
    }
  }

  private getPaidBatchDetails() {
    if (this.batchid && this.providerid) {
      this.service.getPaidBatchDetails(this.batchid, this.providerid).subscribe(
        data => {
          this.batchData = data;
          this.grid.api.setRowData(data.tripdetails);
        }
      );
    }
  }

  private amountCell = function (params: any) {
    return params.value ? '$' + params.value : '';
  };

  private getColumns() {
    return [
      // {
      //   colId: 'check',
      //   checkboxSelection: true,
      //   headerCheckboxSelection: true,
      //   width: 100
      // },
      {
        headerName: 'DOS',
        field: 'dateofservice',
        colId: 'dateofservice',
        width: 200
      },
      {
        headerName: 'Reservation',
        field: 'reservation',
        colId: 'reservation',
        width: 150
      },
      {
        headerName: 'Trip Status',
        field: 'tripstatus',
        colId: 'tripstatus'
      },
      {
        headerName: 'Status',
        field: 'paymentstatus',
        colId: 'paymentstatus',
        width: 150
      },
      {
        headerName: 'Patient',
        field: 'patientname',
        colId: 'patientname'
      },
      {
        headerName: 'Appt',
        field: 'appoinmenttime',
        colId: 'appoinmenttime'
      },
      {
        headerName: 'Sch. PU',
        field: 'scheduleputime',
        colId: 'scheduleputime'
      },
      {
        headerName: 'Act. PU',
        field: 'actualputime',
        colId: 'actualputime'
      },
      {
        headerName: 'Pickup Loc.',
        field: 'pickuplocation',
        colId: 'pickuplocation'
      },
      {
        headerName: 'Act. DO',
        field: 'actualdotime',
        colId: 'actualdotime'
      },
      {
        headerName: 'Dropoff Loc.',
        field: 'dropofflocation',
        colId: 'dropofflocation'
      },
      {
        headerName: 'Driver',
        field: 'drivername',
        colId: 'drivername'
      },
      {
        headerName: 'Vehicle',
        field: 'vehiclenumber',
        colId: 'vehiclenumber'
      },
      {
        headerName: 'Signature',
        field: 'signature',
        colId: 'signature'
      },
      {
        headerName: 'Amnt. Paid to Prov.',
        field: 'amountpaidtoprovider',
        colId: 'amountpaidtoprovider',
        cellRenderer: this.amountCell,
        cellClass: 'text-a-right',
        width: 130
      },
      {
        headerName: 'EOB',
        cellClass: ['text-a-center'],
        cellRendererFramework: EOPButtonComponent,
        colId: 'PDF'
      },
      {
        headerName: 'Claim',
        cellClass: ['text-a-center'],
        cellRendererFramework: ClaimButtonComponent,
        colId: 'ClaimPDF'
      }
    ];
  }

  onGridReady(event) {
    event.api.sizeColumnsToFit();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/providers-billing/payments/components/batch-pay-detail/batch-pay-detail.component.ts